import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import { Application, canAccess } from "@eres/ssoapi/entities";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { SSOProfile } from "@10x/sso/SSOProfile";
import { SSOApp } from "../../../typings/global";
import _ from "lodash";
import { DateUtil, I8N, LocaleUtil, StringUtil } from "@eres/core";
import { AppConstants } from "../../configApp";
import { getName } from "@10x/sso";
import { HideBC } from "@my-dld/components/BreadCrumb";
import { SSOApi } from "@eres/ssoapi";
import { exToMessage, getUaePassUrl } from "@eres/ssoapi/api";
import { GridView, hideLoading, ListView, showErrorMessage } from "@my-dld/utils/UIUtils";
import { dispatch, navigate } from "@my-dld/utils/StoreUtils";
import { withRouter } from "react-router";
import { getUser } from "@my-dld/utils/User";
import UserNotificationView from "@my-dld/components/UserNotification";
import Popup from "@my-dld/components/Popup/Popup";
import { getAppServices } from "@10x/coreapp";
import Switch from "@my-dld/components/Switch";
import Actions from "@my-dld/actions";
import moment from "moment";
import { IAppLoginState } from "../Login";
import * as base64 from "js-base64";
import { JQModal } from "@my-dld/components/Popup/Utils";

interface Props extends RoutedViewProps {

}

interface State {
	isUAEPassUser: boolean;
	apps: Application[];
	myApps: SSOApp[];
	otherApps: SSOApp[];
	soonApps: SSOApp[];
	allLiveApps: SSOApp[];
	isList: boolean;
	ssoAppId?: string;
	ssoCallBack?: string;
}

class MyApps extends Component<Props, State> {
	rootUrl = AppConstants.rootUrlLocale;

	constructor( props: Props ) {
		super( props );
		let { appId, callback } = props.match.params;
		const p = SSOProfile.getProfile();
		const allApps = window.ssoApps ? window.ssoApps.filter( x => x.isLive ) : [];
		const apps: Application[] = [];
		const otherApps: SSOApp[] = [];
		const myApps: SSOApp[] = [];
		const soonApps: SSOApp[] = window.ssoApps ? window.ssoApps.filter( x => !x.isLive ) : [];
		const store = getAppServices().storeService.getStore();
		const viewType = store.getState().User.viewType;
		if ( p && p.applications ) {
			let applications = _.uniqBy( p.applications, x => x.sso ? x.applicationId + "-" + x.sso : x.applicationId );

			apps.push( ...applications );
		}

		allApps.forEach( app => {
			if ( app.universalApp ) return;
			if ( canAccess( app, apps ) ) {
				myApps.push( app );
			} else {
				if ( app.requireSSOAccess !== true )
					otherApps.push( app );
			}
		} );
		const universalApps = allApps.filter( x => x.universalApp === true );
		myApps.push( ...universalApps );
		this.state = {
			apps: apps,
			otherApps: otherApps,
			soonApps: soonApps,
			myApps: myApps,
			allLiveApps: [ ...myApps, ...otherApps ],
			isList: viewType?.Id === ListView.Id,
			isUAEPassUser: p?.loginMethod === "UAEPASS",
			ssoAppId: appId,
			ssoCallBack: callback,
		};
	}

	componentDidMount() {
		// console.log("ALL APPS = ", window.ssoApps);
		// console.log("USer Logged In = ", SSOProfile.getProfile());
	}

	// doLogin = () => {
	// 	let path = "/login";
	// 	if ( !isEmptyStringOrNull( this.state.reLoginModule ) ) {
	// 		path = path + "/" + "sso";
	// 	}
	// 	this.props.history.replace( {
	// 		pathname: path,
	// 	} );
	// };
	redirectX( path: string ) {
		if ( window.hasMyDLD ) {
			this.props.history.push( "/" + path );
		} else {
			window.location.href = this.rootUrl + "MyDLD/#/" + path;
		}
	}

	dismiss = () => {
		JQModal( "application-infoUAE" ).hide();
	};
	loginUAEPass = () => {
		const ln = I8N.locale();
		const appState: IAppLoginState = {
			module: "uaepass",
			sso: true,
			app: this.state.ssoAppId,
			cb: this.state.ssoCallBack,
			ln: ln,
			mode: "login",
		};
		const state = base64.encode( JSON.stringify( appState ) );
		const passUrl = getUaePassUrl( ln, state );
		console.log( "UAEPAss URL origin", passUrl );
		window.location.href = passUrl;
	};

	onProceed = ( app: SSOApp, isUAEPass?: boolean ) => {
		if ( isUAEPass ) {
			JQModal( "application-infoUAE" ).show();
			// navigateWithInParent( "login", "sso" );
			// this.props.history.replace( {
			// 	pathname: '/login/sso',
			// } );

			// const u = getUser();
			// let ssoP = SSOProfile.getProfile();
			// if ( u && ssoP ) {
			// 	u.removeProfile( ssoP );
			// }
			// dispatch( {
			// 	type: Actions.USER_REFRESHING,
			// 	payload: false,
			// } );

			// const isTabuUser = TabuProfile.getProfile() != null;
			// const pathX = isTabuUser ? "/owner" : "/sso";
			//
			// this.redirectX( "logout" + pathX );
			return;
		}
		const verticalAppUrl = LocaleUtil.getLocalValue( app?.verticalAppProfileUrl );
		if ( verticalAppUrl && verticalAppUrl.length ) {
			dispatch( Actions.SET_APPLICATION, app );
			navigate( "/mydld/profiles", "", { application: app } );
		} else {
			const user = SSOProfile.getProfile();
			console.log( "user = ", user );
			const url = LocaleUtil.getLocalValue( app?.url );
			if ( url ) {
				hideLoading();
				if ( url.startsWith( "#" ) ) {
					let xp = url.substr( 1 );
					navigate( xp );
				} else {
					window.open( url + "?ln=" + I8N.locale(), "_" + app.id );
				}
			}
		}
		//const authMethods = app.allowedAuthenticationMethods;
		// if ( authMethods && authMethods.uaePass && !authMethods.emiratesID && !authMethods.userNamePassword) {
		// 	 const user = SSOProfile.getProfile();
		// 	// this.onUaePass(app);
		// 	// return;
		// 	if (user?.loginMethod !== "UAEPASS") {
		// 		showErrorMessage( "ONLY UAE PASS");
		// 		return;
		// 	}
		// } else {
		// 	console.log("PROFILE = ", SSOProfile.getProfile());
		// 	console.log("APPLICATION = ", app);
		// 	const verticalAppUrl = LocaleUtil.getLocalValue( app?.verticalAppProfileUrl );
		// 	if (verticalAppUrl && verticalAppUrl.length) {
		// 		navigate("/mydld/profiles", "", {application: app});
		// 	} else {
		// 		const user = SSOProfile.getProfile();
		// 		console.log("user = ", user);
		// 		const url = LocaleUtil.getLocalValue( app?.url );
		// 		if ( url ) {
		// 			hideLoading();
		// 			if ( url.startsWith( "#" ) ) {
		// 				let xp = url.substr( 1 );
		// 				navigate( xp );
		// 			} else {
		// 				window.open( url + "?ln=" + I8N.locale(), "_" + app.id );
		// 			}
		// 		}
		// 	}
		// }
	};

	render() {
		const { isList } = this.state;
		const notifications = getUser()?.getUserNotification();

		return (
			<React.Fragment>
				<HideBC/>
                <div className="container company-dboard">

					<div className="dashboard-user-title hide">
						<h5>
							{ Strings.welcome } { LocaleUtil.getLocalValue( getName() ) }
							<small>{ DateUtil.formatDate( new Date(), "Do MMMM YYYY" ) }</small>
						</h5>
						<div className="dashboard-user-action">
							<button
								type="button" className="btn btn-sm" onClick={ () => {
								navigate( "/mydld/profile" );
							} }>
								<i className="icon-profile"/>
								<span>{ Strings.profile }</span>
							</button>
							<button
								type="button" className="btn btn-sm" onClick={ () => {
								if ( window.showMyDLDLogout ) window.showMyDLDLogout();
							} }>
								<i className="icon-logout"/>
								<span>{ Strings.sign_out }</span>
							</button>
						</div>
					</div>
					{ notifications &&
						<>
							{
								notifications.map( ( value, index ) =>
									<UserNotificationView
										key={ "notification-" + index }
										showResolve={ true }
										notification={ value }
										wrapperClass={ "d-flex " }
										alertClass={ "flex-grow-1" }/> )
							}
						</> }
                    <div className={ "row g-3" + ( isList ? " dcard-list-view" : "" ) }>

						<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
							<div className="page-title">
								<div>
									{ Strings.welcome_to_dubai_land_department_application_dashboard }
								</div>
								<Switch
									id={ "viewType" }
									onLabel={ Strings.list }
									onIcon={ <i className="icon-grid-view"/> }
									offLabel={ Strings.grid }
									offIcon={ <i className="fa fa-th-list"/> }
									value={ isList }
									onChange={ this.onViewTypeChange }
									extraContainerClass={ "tr-map-list" }
								/>
							</div>
							<div className="page-title-help-text hide">{ Strings.want_to_know_more_about_each_application }
								<a
									href="#" className="underline" data-bs-toggle="modal"
                                    data-bs-target="#application-info">{Strings.click_here_caps}</a></div>
                            <div className="position-relative w-100">
                                <label className="sr-only" htmlFor="searchMyapps">{ Strings.search } </label>
                                <input type="text" id="searchMyapps" className="form-control search-field-icon" placeholder={ Strings.search } />
                                <button className="btn txt-clear-btn" type="button" id="txt_clear_btn"><i className="material-icons-outlined">close</i></button>
                            </div>
						</div>

						{ this.state.myApps.map( app => {
							return <AppItem
								isUAEPassLogin={ this.state.isUAEPassUser } key={ app.id + "-" + ( app.sso ?? "" ) } app={ app } isOpen={ true }
								onProceed={ this.onProceed } isList={ isList }/>;
						} )
						}
						{ this.state.otherApps.map( app => {
							return <AppItem
								isUAEPassLogin={ this.state.isUAEPassUser } key={ app.id + "-" + ( app.sso ?? "" ) } app={ app } isReg={ true }
								onProceed={ this.onProceed } isList={ isList }/>;
						} )
						}
					</div>
					{ this.state.soonApps && this.state.soonApps.length > 0 &&
						<React.Fragment>
							<div className="row g-3">
								<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
									<div className="page-title">
										<div>{ Strings.dld_account_coming_soon }</div>
									</div>
									<small className="page-title-help-text">
										{ Strings.dld_account_coming_soon_account }
									</small>
								</div>
								{ this.state.soonApps && this.state.soonApps.map( app => {
									return <AppItem
										isUAEPassLogin={ this.state.isUAEPassUser } key={ app.id } app={ app } onProceed={ this.onProceed }
										isList={ isList }/>;
								} )
								}
							</div>
						</React.Fragment>
					}

					<Popup
						id={ "application-info" }
						modalMainContainer={ "modal fade" }
						showCloseButton={ true }
						closeClass={ "close modal-close-svg-icon" }
						closeSpanClass={ "close-svg-icon" }
						modalBodyContainer={ "modal-body" }
						modalSubContainer={ "modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable" }
						showIcon={ false }
						title={ Strings.info }>
						<div className="row">
							{ this.state.allLiveApps && this.state.allLiveApps.map( app => {
								return <div className="col-12 content-section mb-3" key={ app.id }>
									<div className="content-section-title fs-6">
                                        <span
	                                        className="section-title-span">{ LocaleUtil.getLocalValue( app.name ) }</span>
									</div>
									<span className="font14 fs-6">{ app.desc_key ? Strings[ app.desc_key ] : "" }</span>
								</div>;
							} )
							}
						</div>
						<div className="modal-footer d-flex justify-content-center hide">
							<button type="button" className="btn btn_1">{ Strings.home }</button>
						</div>
					</Popup>
					<Popup
						id={ "application-infoUAE" }
						modalMainContainer={ "modal fade" }
						showCloseButton={ true }
						closeClass={ "close modal-close-svg-icon" }
						closeSpanClass={ "close-svg-icon" }
						modalBodyContainer={ "modal-body" }
						modalSubContainer={ "modal-dialog modal-dialog-centered" }
						showIcon={ false }
						title={ Strings.info }>
						<div className="row">
							<div className="icon-exclamation-triangle">
								<i className="fa fa-exclamation-triangle"></i>
							</div>
							<p className="text-center">
								{ Strings.need_uae_pass }
							</p>
						</div>
						<div className="modal-footer pb-0 px-0 justify-content-center">
							<button type="button" className="btn btn_1" onClick={ this.dismiss }>{ Strings.stay_dashboard }</button>
							<button type="button" className="btn btn-uaepass-continue" onClick={ this.loginUAEPass }></button>
						</div>
					</Popup>
				</div>
			</React.Fragment>
		);
	}

	private onViewTypeChange = ( isList: boolean ) => {
		this.setState( {
			isList: isList,
		}, () => {
			const newType = isList ? ListView : GridView;
			dispatch( Actions.VIEW_TYPE_CHANGED, newType );
		} );
	};
}

export default withRouter( MyApps );

interface AppProps {
	isUAEPassLogin: boolean;
	app: SSOApp,
	isOpen?: boolean;
	isReg?: boolean;
	isList?: boolean;
	onProceed: ( app: SSOApp, isUAEPass?: boolean ) => void;
}

function AppItem( props: AppProps ) {
	const { app, isOpen, isReg, onProceed, isList } = props;
	const newAppTill = app?.newAppTill;
	const isNewApp = React.useMemo( () => {
		if ( app?.newAppTill ) {
			try {
				let inp = DateUtil.parseDate( app.newAppTill, "YYYY-MM-DD", "en" );
				inp = DateUtil.normatizeDate( inp );
				const m = moment( inp );
				if ( m.isValid() ) {
					let now = moment(); // .add( 2, "day");
					const diff = now.diff( m, "days" );
					return diff <= 0;
				}
			} catch ( e ) {

			}
		}
		return false;
	}, [ newAppTill ] );
	if ( app == null ) return null;
	const name = LocaleUtil.getLocalValue( app.name );
	let desc = "";
	if ( app.desc_key ) {
		if ( Strings.hasOwnProperty( app.desc_key ) ) {
			desc = Strings[ app.desc_key ];
		}
	}
	let iconUrl = LocaleUtil.getLocalValue( { en: app.iconEn, ar: app.iconAr } );
	iconUrl = iconUrl ? iconUrl : app.icon ? LocaleUtil.getLocalValue( app.icon ) : AppConstants.rootUrl + "assets/img/land_department.png";
	const enableReg = isReg && canRegisterApp( app );
	const open = () => {
		onProceed( app );
	};
	const regMe = () => {
		register( app );
	};
	const loginUAEPass = () => {
		onProceed( app, true );
	};
	let openLabel = Strings.go_to_account;
	const openKey = app.openKey;
	if ( openKey && Strings[ openKey ] ) {
		openLabel = Strings[ openKey ];
	}
	const p = SSOProfile.getProfile();
	let isUAEPassRequired = false;
	const s = Object.keys( app.allowedAuthenticationMethods );
	if ( !props.isUAEPassLogin && s.length === 1 && s.find( v => v === "uaePass" ) !== undefined ) {
		if ( app.verticalAppProfileUrl && app.verticalAppProfileUrl.length ) {
			isUAEPassRequired = true;
		}
		const userApp = p?.applications?.find( a => a.applicationId === app.id );
		if ( userApp && userApp.policies && userApp.policies.allowedLoginMethods && userApp.policies.allowedLoginMethods.length > 0 ) {
			isUAEPassRequired = userApp.policies.allowedLoginMethods.filter( p => p === "USERID_PASSWORD" || p === "EID_PASSCODE" ).length === 0;
		}
	}
    const classNameXX = isUAEPassRequired ? "col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 card-ts2" : "col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 card-ts2";
	return <div className={ classNameXX }>
		<div
            className="card company-dcard" onClick={ () => {
			if ( !isList ) {
				if ( isOpen ) open();
				if ( enableReg ) regMe();
			}
            }}>
            <div className="card-body">
                {isNewApp && <span className="b-new-tag badge bg-danger">{Strings.new}</span>}
                <div className="wrap-nameicon">
                    <div className="service-icon">
                        <img
                            className={"img-fluid b-app-logo-" + app.id}
                            src={iconUrl} alt="app logo" />
                    </div>
                    <div className="service-name">
                        <div>{name}</div>
                        <div className="service-description des-list-view">
                            {desc}
                        </div>
                    </div>
                </div>
                <div className="service-description mt-3">
                    {desc}
                </div>
			</div>
            <div className="card-footer">
				{
					isUAEPassRequired && !enableReg &&
                    <button className="btn btn_1_outline" onClick={ loginUAEPass }><span >{ Strings.sso_login_with_uae_pass }</span>
					</button>
				}
                {
                    !isUAEPassRequired && isOpen && <button className="btn btn_1_outline" onClick={open}>{openLabel}</button>
				}
				{
					!isUAEPassRequired && enableReg && <button
                        className="btn btn-grey" onClick={ isOpen ? open : enableReg ? regMe : () => {
					} }>{ Strings.register }</button>
				}
				{
                    isUAEPassRequired && enableReg && <button className="btn btn_1_outline" onClick={ regMe }>{ Strings.register }</button>
				}
			</div>

			{/* Go To Account */ }
			{/*{ isOpen &&*/ }
			{/*	<div className="card-footer">*/ }
			{/*		<button className="btn btn_link" onClick={ open }>{ openLabel }</button>*/ }
			{/*	</div>*/ }
			{/*}*/ }
			{/*/!* Sign Up *!/*/ }
			{/*{ enableReg &&*/ }
			{/*	<div className="card-footer">*/ }
			{/*		<button className="btn btn_link" onClick={ regMe }>{ Strings.register }</button>*/ }
			{/*	</div> }*/ }

		</div>
	</div>;
}

export function canRegisterApp( app: SSOApp ) {
	let url = LocaleUtil.getLocalValue( app.signUpUrl );
	return !StringUtil.isEmptyStringOrNull( url ) && app.signUpMode && app.signUpMode !== "disabled";
}

export function register( app: SSOApp ) {
	const signUpMode = app.signUpMode;
	let signUpUrl = LocaleUtil.getLocalValue( app.signUpUrl );
	if ( signUpMode === "sso" ) {
		if ( window.AppInfo.disableSSORegValidation ) {
			window.open( signUpUrl + "?ln=" + I8N.locale(), "_" + app.id );
		} else {
			SSOApi.register.validateApplication( app.id ).then( _x => {
				window.open( signUpUrl + "?ln=" + I8N.locale(), "_" + app.id );
			} ).catch( e => {
				exToMessage( e ).then( message => {
					if ( message && message.content && message.content.error && message.content.error.code === "CreateFail" ) {
						navigate( "/mydld/profile/newaccount", undefined, { appId: app.id } );
						return;
					}
					showErrorMessage( message.error );
				} );
			} );
		}
	} else if ( signUpMode === "app" ) {
		window.open( signUpUrl + "?ln=" + I8N.locale(), "_" + app.id );
	}

}
